import type { GetUserTablePreferencesResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetUserTablePreferencesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetUserTablePreferencesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetUserTablePreferencesArgs = {
  tableId: string;
};

export const useGetUserTablePreferences = createQueryHook<
  UseGetUserTablePreferencesArgs,
  GetUserTablePreferencesResponseRow[],
  GetUserTablePreferencesQuery
>({
  trpcQueryOptions: (trpc, { tableId }) =>
    trpc.frontend.userTablePreferences.userTablePreferences.queryOptions({
      tableId,
    }),
  // Legacy query root is the `user_table_preferences` array (0..1 actor-pinned
  // rows); the tRPC procedure returns the unwrapped rows.
  mapTrpcDataToGraphQL: (data) => ({
    user_table_preferences: data,
  }),
  graphqlDocument: GetUserTablePreferencesDocument,
  graphqlVariables: ({ tableId }) => ({ TableId: tableId }),
});
